/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class InventoryGcpDisk {
  /**
  * he unique identifier for the resource. This identifier is defined by the server
  */
  'diskId': string;
  /**
  * The type of the disk.
  */
  'diskType': string;
  /**
  * The size of the disk in bytes.
  */
  'diskSizeBytes': number;
  /**
  * The name of the disk.
  */
  'diskName': string;
  /**
  * Indicates whether the disk is a boot disk.
  */
  'isBootDisk'?: boolean;
  /**
  * Disk IOPS.
  */
  'iops'?: number;
  /**
  * Disk throughput.
  */
  'throughput'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "diskId",
      "baseName": "diskId",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskType",
      "baseName": "diskType",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskSizeBytes",
      "baseName": "diskSizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "diskName",
      "baseName": "diskName",
      "type": "string",
      "format": ""
    },
    {
      "name": "isBootDisk",
      "baseName": "isBootDisk",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "iops",
      "baseName": "iops",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "throughput",
      "baseName": "throughput",
      "type": "number",
      "format": "int64"
    }  ];

  static getAttributeTypeMap() {
    return InventoryGcpDisk.attributeTypeMap;
  }

  public constructor() {
  }
}

